// src/components/TagDialog.jsx
import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Checkbox, List, ListItem, ListItemText, TextField } from '@mui/material';
import axiosInstance from '../api/axiosInstance';

function TagDialog({ open, onClose, onConfirm, existingTags = []  }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [closeFriends, setCloseFriends] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    loadCloseFriends();
  }, []);

  const loadCloseFriends = async () => {
    try {
      const resp = await axiosInstance.get('/flashes/close-users');
      setCloseFriends(resp.data.users || []);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSearch = async (val) => {
    setSearchTerm(val);
    if (!val) {
      setFiltered([]);
      return;
    }
    try {
      const resp = await axiosInstance.get('/flashes/search-users', { params: { query: val } });
      setFiltered(resp.data.users || []);
    } catch (err) {
      console.error(err);
    }
  };

  const displayed = searchTerm
  ? filtered.filter(
      (user) => !existingTags.some((taggedUser) => taggedUser.user_id === user.user_id)
    )
  : closeFriends.filter(
      (user) => !existingTags.some((taggedUser) => taggedUser.user_id === user.user_id)
    );
  useEffect(() => {
    // Make sure we store them as user objects, not just IDs
    setSelected(existingTags);
  }, [existingTags]);
  const toggleSelect = (u) => {
    setSelected((prev) => {
      const found = prev.find((x) => x.user_id === u.user_id);
      if (found) {
        return prev.filter((x) => x.user_id !== u.user_id);
      }
      return [...prev, u];
    });
  };

  const handleConfirm = () => {
    onConfirm(selected.map((u) => u.user_id), selected);
  };
  

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            borderRadius: "12px",
            padding: "14px",
            maxWidth: "400px",
            width: "100%",
          },
        },
      }}
    >
      <DialogTitle>Tag users</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search users..."
          value={searchTerm}
          onChange={(e) => handleSearch(e.target.value)}
          sx={{
            backgroundColor: "#f9f9f9",
            borderRadius: "8px",
            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
            "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
          }}
        />
        <List sx={{ maxHeight: "250px", overflowY: "auto", mt: 1 }}>
          {displayed.map((user) => (
            <ListItem
              key={user.user_id}
              button
              onClick={() => toggleSelect(user)}
              sx={{
                padding: 0,
                borderRadius: "6px",
                "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.05)" },
              }}
            >
              <Checkbox checked={!!selected.find((x) => x.user_id === user.user_id)} />
              <ListItemText primary={user.username} />
            </ListItem>
          ))}
        </List>
        <List>
          {existingTags.map((user) => (
            <ListItem
              key={user.user_id}
              button
              onClick={() => toggleSelect(user)}
              sx={{
                padding: 0,
                borderRadius: "6px",
                "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.05)" },
              }}
            >
              <Checkbox checked={!!selected.find((x) => x.user_id === user.user_id)} />
              <ListItemText primary={user.username} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "space-evenly" }}>
        <Button
          onClick={handleConfirm}
          sx={{
            textTransform: "none",
            fontSize: "16px",
            padding: "5px 16px",
            backgroundColor: "#2c3e50",
            color: "white",
            borderRadius: "5px",
          }}
        >
          Confirm
        </Button>
        <Button
          onClick={onClose}
          sx={{
            textTransform: "none",
            fontSize: "16px",
            padding: "5px 16px",
            backgroundColor: "#ff3040",
            color: "white",
            borderRadius: "5px",
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default TagDialog;
